import React from 'react';
import {
  List,
  Filter,
  Datagrid,
  BooleanField,
  ReferenceInput,
  SelectInput,
  EditButton,
  TextInput,
  TextField,
  NumberField,
  FunctionField,
} from "react-admin";
import * as XLSX from "xlsx";

const TechnicalServiceTitle = () => {
  return <span>Servicio Técnico</span>;
};

const TechnicalServiceFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Buscar nombre" source="name" alwaysOn />
    <ReferenceInput
      label="Provincia"
      source="province"
      reference="provinces"
      allowEmpty
    >
      <SelectInput optionText="name" label="Provincia" />
    </ReferenceInput>
  </Filter>
);

// Función personalizada de exportación
const technicalServiceExporter = (data) => {
  const exportData = data.map((record) => ({
    ID: record.id,
    Nombre: record.name,
    Provincia: record.province?.name || "-",
    Ciudad: record.city || "-",
    Dirección: record.address || "-",
    Teléfono: record.phone || "-",
    Activo: record.active ? "Sí" : "No",
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(exportData);

  const colWidths = Object.keys(exportData[0]).map((h) => ({
    wch: Math.max(h.length, 15),
  }));
  ws["!cols"] = colWidths;

  XLSX.utils.book_append_sheet(wb, ws, "Servicios Técnicos");
  XLSX.writeFile(
    wb,
    `servicios-tecnicos-${new Date().toISOString().split("T")[0]}.xlsx`
  );
};

export const TechnicalServiceList = (props) => (
  <List
    filters={<TechnicalServiceFilter />}
    title={<TechnicalServiceTitle />}
    {...props}
    sort={{ field: "id", order: "ASC" }}
    exporter={technicalServiceExporter}
  >
    <Datagrid rowClick="edit">
      <NumberField source="id" label="ID" />
      <TextField source="name" label="Nombre" />
      <FunctionField
        label="Provincia"
        render={(record) => {
          return record.province?.name || "-";
        }}
      />
      <TextField source="city" label="Ciudad" />
      <TextField source="address" label="Dirección" />
      <TextField source="phone" label="Teléfono" />
      <BooleanField source="active" label="Activo" />
      <EditButton />
    </Datagrid>
  </List>
);